import { useMutation, useQueryClient } from '@tanstack/react-query'
import { getGetAdminContentQueryKey } from '@/types/origin-point-engine'
import { postReviewEngine } from '../lib/review.api'
import type { ReviewAction } from '../types/review.types'

export function useReviewAction() {
  const qc = useQueryClient()

  const mutation = useMutation({
    mutationFn: (input: {
      engineId: string
      action: ReviewAction
      note: string
    }) => postReviewEngine(input),

    onSuccess: async () => {
      await qc.invalidateQueries({
        queryKey: getGetAdminContentQueryKey(),
      })
    },
  })

  return {
    review: mutation.mutate,
    isPending: mutation.isPending,
    error: mutation.error,
  }
}
